import {CANCELLATION_POLICY, CONFIRMATION_POLICY} from "./enums";
import {isValidDateObject} from "../date/validators";
import {dmyString} from "../date/formatters";

export const getConfirmationPolicyText = (confirmationPolicy, depositPercentage=null) => {
    switch (confirmationPolicy) {
        case CONFIRMATION_POLICY.deposit:
            if(depositPercentage !== null){
                return `Pagamento caparra del ${depositPercentage}%`
            }
            else{
                return "Pagamento caparra"
            }
        case CONFIRMATION_POLICY.prePaid:
            return "Pagamento importo anticipato"
        case CONFIRMATION_POLICY.none:
            return "Nessuna (non specificata)"
        default:
            throw new Error(`Unknown confirmation policy ${confirmationPolicy}`);
    }
}

export const getCancellationPolicyText = (policy, refundableUntil=null) => {
    switch (policy) {
        case CANCELLATION_POLICY.notRefundable:
            return "Non rimborsabile"
        case CANCELLATION_POLICY.timeRestrictedRefundable:
            if(isValidDateObject(refundableUntil)){
                return `Rimborsabile fino al ${dmyString(refundableUntil)}`
            }
            else{
                return "Rimborsabile ma con limite di tempo"
            }
        case CANCELLATION_POLICY.totallyRefundable:
            return "Rimborsabile"
        case CANCELLATION_POLICY.none:
            return "Nessuna (non specificata)"
        default:
            throw new Error(`Unknown cancellation policy ${policy}`);
    }
}

export const getTouristTaxPolicyText = (touristTaxPolicy, touristTaxUnitPrice=null) => {
    switch (touristTaxPolicy) {
        case "none":
            return "Nessuna (non specificata)"
        case "included":
            return "Tassa di soggiorno inclusa nel prezzo"
        case "excluded":
            if(Number.isFinite(touristTaxUnitPrice)) {
                return `Tassa di soggiorno esclusa dal prezzo (${touristTaxUnitPrice.toFixed(2)} € a persona)`
            } else {
                return "Tassa di soggiorno esclusa dal prezzo"
            }
        default:
            throw new Error(`Unknown tourist tax policy ${touristTaxPolicy}`);
    }
}
